interface SectionTitleProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
  accent?: 'primary' | 'accent' | 'secondary';
  asHeading?: 'h1' | 'h2';
}

const accentText: Record<string, string> = {
  primary: 'text-primary-500',
  accent: 'text-accent-500',
  secondary: 'text-secondary-400',
};

export default function SectionTitle({
  title,
  subtitle,
  moreTo,
  moreLabel = '查看更多',
  icon,
  accent = 'primary',
  asHeading = 'h2',
}: SectionTitleProps) {
  const Heading = asHeading;
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="h-6 w-1 rounded-full bg-primary-500" />
        <div>
          <Heading className="flex items-center gap-2 text-xl font-bold text-foreground-50 md:text-2xl">
            {icon && <i className={`${icon} text-lg ${accentText[accent]}`} />}
            {title}
          </Heading>
          {subtitle && <p className="mt-1 max-w-3xl text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="hidden shrink-0 items-center gap-1 text-sm text-foreground-400 transition-colors hover:text-primary-500 sm:flex"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}